var render, staticRenderFns
import script from "./checkIcon.vue?vue&type=script&lang=js&"
export * from "./checkIcon.vue?vue&type=script&lang=js&"
import style0 from "./checkIcon.vue?vue&type=style&index=0&id=0a81b0f7&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports